export const INFO_URL = 'https://yandex.ru/support2/rythm/ru/buisness/promotion';
